import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateUserActivityElements } from '../../../redux/slices/userActivity';
import { EditText } from "react-edit-text";

export default function NpsPositiveNegativeText() {

    const { selectedUserActivity, userActivities, selectedComponent } = useSelector((state) => state.userActivity);
    const [positiveText, setpositiveText] = useState("");
    const [negativeText, setnegativeText] = useState("");
    const dispatch = useDispatch()

    useEffect(() => {
        if (userActivities[selectedUserActivity].elements.length >= 1) {
            let tempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
            const negativeText = tempElement?.elementAttributes?.negativeText;
            const positiveText = tempElement?.elementAttributes?.positiveText;
            if (negativeText) {
                setnegativeText(negativeText);
            } else {
                setnegativeText("");
            }
            if (positiveText) {
                setpositiveText(positiveText);
            } else {
                setpositiveText("");
            }
        }
    }, [selectedUserActivity, userActivities[selectedUserActivity], selectedComponent.target_id]);

    const handleNegativeTextChange = (e) => {
        // console.log(e)
        const value = e.target.value;
        setnegativeText(value);

        if (userActivities[selectedUserActivity].elements.length >= 1) {
            let tempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
            const elementAttrib = tempElement?.elementAttributes;
            tempElement = {
                ...tempElement,
                elementAttributes: {
                    ...elementAttrib,
                    negativeText: value,
                },
            };
            // console.log("tempElement", tempElement)
            dispatch(
                updateUserActivityElements({
                    selectedActivityIdx: selectedUserActivity,
                    selectedElementIdx: selectedComponent.target_id,
                    element: tempElement,
                })
            );
        }
    }

    const handlePositiveTextChange = (e) => {
        // console.log(e)
        const value = e.target.value;
        setpositiveText(value);

        if (userActivities[selectedUserActivity].elements.length >= 1) {
            let tempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
            const elementAttrib = tempElement?.elementAttributes;
            tempElement = {
                ...tempElement,
                elementAttributes: {
                    ...elementAttrib,
                    positiveText: value,
                },
            };
            // console.log("tempElement", tempElement)
            dispatch(
                updateUserActivityElements({
                    selectedActivityIdx: selectedUserActivity,
                    selectedElementIdx: selectedComponent.target_id,
                    element: tempElement,
                })
            );
        }
    }

    return (
        <>
            <div className="EditorRowContainer">
                <div style={{ marginRight: "0.5rem" }}>Negative Text</div>
                <EditText
                    id="negativeText-input-field"
                    value={negativeText}
                    onEditMode={() => { setTimeout(() => document.querySelector(`#negativeText-input-field`).select(), 100); }}
                    style={{ fontSize: "14px", border: "1px solid #11111333", borderRadius: "5px", backgroundColor: "white", display: "flex", justifyContent: "flex-start", alignItems: "center", width: "15rem", height: "28px", paddingLeft: "5px" }}
                    onChange={(e) => (handleNegativeTextChange(e))}
                    placeholder="Write your Negative Side Text?"
                />

            </div>

            <div className="EditorRowContainer">
                <div style={{ marginRight: "1rem" }}>Positive Text</div>
                <EditText
                    id="positiveText-input-field"
                    value={positiveText}
                    onEditMode={() => { setTimeout(() => document.querySelector(`#positiveText-input-field`).select(), 100); }}
                    style={{ fontSize: "14px", backgroundColor: "white", border: "1px solid #11111333", borderRadius: "5px", display: "flex", justifyContent: "flex-start", alignItems: "center", width: "15rem", height: "28px", paddingLeft: "5px" }}
                    onChange={(e) => (handlePositiveTextChange(e))}
                    placeholder="Write your Positive Side Text?"
                />
            </div>
        </>
    )
}

